<template>
  <div class="app-container" v-if="isLoaded">
    <basic-container>
      <el-form label-position="top" :rules="rules" ref="ruleForm" id="ruleForm" :model="form" size="medium">
        <div v-show="isBasicInfo">
          <el-form-item label="列表页图片" prop="listPageImage">
            <template slot="label">
              列表页图片 <span class="image-upload-tip">(推荐尺寸为318×318像素)</span>
            </template>

            <el-col :span="15">
              <div v-if="form.listPageImage" class="activity-image-wrapper">
                <img class="activity-list-page-image" :src="form.listPageImage | ossImageProcess">
                <el-button type="text" @click="form.listPageImage = ''" icon="icon-remove-image" class="image-remove-icon"></el-button>
              </div>
              <el-button v-else type="text" @click="handleListPageImageChange" icon="icon-add-cover"></el-button>
            </el-col>
          </el-form-item>
          <!-- <el-form-item label="详情页图片" prop="image">
            <template slot="label">
              详情页图片 <span class="image-upload-tip">(推荐尺寸为750×320像素)</span>
            </template>

            <el-col :span="15">
              <div v-if="form.image" class="activity-image-wrapper">
                <img class="activity-image" :src="form.image | ossImageProcess">
                <el-button type="text" @click="form.image = ''" icon="icon-remove-image" class="image-remove-icon"></el-button>
              </div>
              <el-button v-else type="text" @click="handleImageChange" icon="icon-add-cover"></el-button>
            </el-col>
          </el-form-item> -->

          <el-form-item label="培训名称" prop="name">
            <el-col :span="15">
              <el-input v-model="form.name" :maxlength="200"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="培训名称（英文）" prop="nameEn">
            <el-col :span="15">
              <el-input v-model="form.nameEn" :maxlength="200"></el-input>
            </el-col>
          </el-form-item>

          <!-- <el-form-item label="培训类型" prop="type">
            <el-col :span="15">
              <el-select v-model="form.type" placeholder="培训类型">
                <el-option
                  v-for="(item, index) in activityTypes"
                  :key="index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-form-item> -->

          <el-form-item label="培训时间" prop="startEndTime">
            <el-col :span="15">
              <el-date-picker
                :default-time="['00:00:00', '23:59:00']"
                v-model="form.startEndTime"
                type="datetimerange"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
              </el-date-picker>
            </el-col>
          </el-form-item>

          <el-form-item label="是否只显示日期">
            <el-col :span="15">
              <el-switch v-model="form.isOnlyShowDate"></el-switch>
            </el-col>
          </el-form-item>

          <el-form-item label="培训地点" prop="place">
            <el-col :span="15">
              <el-input v-model.trim="form.place" :maxlength="200"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="培训地点（英文）" prop="placeEn">
            <el-col :span="15">
              <el-input v-model.trim="form.placeEn" :maxlength="200"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="课程类别" prop="category">
            <el-col :span="12">
            <el-select v-model="form.category" placeholder="请选择课程类别">
              <el-option
                v-for="(item, index) in categoryOptions"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            </el-col>
          </el-form-item>

          <el-form-item label="培训内容" prop="content">
            <el-col :span="15">
              <rich-text-editor v-model="form.content" placeholder="输入培训内容" @onblur="handleContentOnBlur" :ossImageFolder="ossImageFolder" :ossVideoFolder="ossVideoFolder" :ossFileFolder="ossFileFolder"></rich-text-editor>
            </el-col>
          </el-form-item>

          <el-form-item label="培训内容（英文）" prop="contentEn">
            <el-col :span="15">
              <rich-text-editor v-model="form.contentEn" placeholder="输入培训内容（英文）" @onblur="handleContentEnOnBlur" :ossImageFolder="ossImageFolder" :ossVideoFolder="ossVideoFolder" :ossFileFolder="ossFileFolder"></rich-text-editor>
            </el-col>
          </el-form-item>

          <el-form-item label="报名截止时间" prop="joinEndTime">
            <el-col :span="8">
              <span>项目开始前：</span>
              <el-input-number controls-position="right" v-model="form.joinEndBeforeProjectStartHours" :step="1" :min="0" v-input-int></el-input-number>
              <span>&nbsp;小时</span>
            </el-col>
          </el-form-item>

          <el-form-item label="“取消报名”截止时间">
            <el-col :span="8">
              <span>项目开始前：</span>
              <el-input-number controls-position="right" v-model="form.beforeProjectStartHours" :step="1" :min="0" v-input-int></el-input-number>
              <span>&nbsp;小时</span>
            </el-col>
          </el-form-item>
          <el-form-item class="enroll-scopes-select" label="报名范围" prop="enrollScopes">
            <el-col :span="15">
              <el-select v-model="form.enrollScopes" placeholder="报名范围" multiple @remove-tag="handleEnrollScopeRemove" filterable :filter-method="filterMethod" :popper-append-to-body="false">
                <el-option
                  v-for="(item, index) in enrollScopeList"
                  :key="index"
                  :label="item.tagName"
                  :value="item.id"
                  :disabled="item.disabled">
                </el-option>
            </el-select>
            </el-col>
          </el-form-item>

          <div class="operation">
            <el-button @click="cancel" size="medium">取消</el-button>
            <el-button type="primary" @click="handleNextStep" size="medium">下一步</el-button>
          </div>
        </div>
        <div v-show="!isBasicInfo">
          <el-form-item label="是否显示项目容纳人数">
            <el-col :span="15">
              <el-switch v-model="form.showCapacity"></el-switch>
            </el-col>
          </el-form-item>

          <el-form-item label="是否显示项目剩余名额">
            <el-col :span="15">
              <el-switch v-model="form.showRemainingPlaces"></el-switch>
            </el-col>
          </el-form-item>

          <el-form-item label="培训项目选择模式" v-show="form.multipleProjectsMode">
            <el-col :span="15">
              <el-radio v-model="form.multipleProjectsChoseMode" :label="false">单项</el-radio>
              <el-radio v-model="form.multipleProjectsChoseMode" :label="true">多项</el-radio>
            </el-col>
          </el-form-item>

          <el-form-item label="用户可报名的子项目总数" v-show="form.multipleProjectsMode && form.multipleProjectsChoseMode">
            <el-col :span="5">
              <el-input-number controls-position="right" v-model="form.minEnrollProjects" :step="1" :min="1" @blur="resetMinEnrollProjects" :max="form.maxEnrollProjects" v-input-int></el-input-number>
            </el-col>
            <el-col :span="1">-</el-col>
            <el-col :span="4">
              <el-input-number controls-position="right" v-model="form.maxEnrollProjects" :step="1" :min="form.minEnrollProjects" v-input-int placeholder="不填则不限制总数"></el-input-number>
            </el-col>
          </el-form-item>

          <el-form-item label="是否需要报名审批">
            <el-switch :disabled="form.supportQueue" v-model="form.needApprove"></el-switch>
            <i class="el-icon-question tip-icon" :title="'开启报名审批后，则不支持开启排队机制'"></i>
            </el-form-item>
            
          <el-form-item label="是否支持排队机制">
            <el-switch :disabled="form.needApprove" v-model="form.supportQueue"></el-switch>
            <i class="el-icon-question tip-icon" :title="'开启支持排队机制后，则不支持开启报名审批'"></i>
          </el-form-item>

          <el-form-item label="排队截止时间" v-show="form.supportQueue">
            <el-col :span="8">
              <span>项目开始前：</span>
              <el-input-number controls-position="right" v-model="form.queueEndBeforeProjectStartHours" :step="1" :min="0" v-input-int></el-input-number>
              <span>&nbsp;小时</span>
            </el-col>
          </el-form-item>

          <el-form-item label="项目组列表:" prop="projectGroups">
            <el-card class="box-card" v-for="(projectGroup, index) in form.projectGroups" :key="index">
              <!-- 项目组信息 -->
              <div v-show="form.multipleProjectsMode">项目组{{ index + 1 }}： {{projectGroup.name}}（{{ projectGroup.nameEn }}）</div>
              <div v-show="form.multipleProjectsMode">
                {{!projectGroup.hint ? '--' : projectGroup.hint}}（{{ !projectGroup.hintEn ? '--' : projectGroup.hintEn }}）
                <span v-show="form.multipleProjectsChoseMode">（用户可报名{{parseInt(projectGroup.maxEnrollProjects) ? (projectGroup.minEnrollProjects + '-' + projectGroup.maxEnrollProjects + '项') : ('至少' + projectGroup.minEnrollProjects + '项')}}）</span>
                <el-button type="text" icon="icon-edit" size="mini" @click="editProjectGroup(projectGroup, index)"></el-button>
                <el-button type="text" icon="icon-delete" size="mini" @click="handleRemoveProjectGroups(index)"></el-button>
              </div>
              <!-- 此项目组下的子项目信息 -->
              <el-table border :data="projectGroup.subProjectList || []" style="width: 90%; margin-left: 30px" max-height="300">
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="nameEn" label="名称（英文）"></el-table-column>
                <el-table-column v-if="form.multipleProjectsMode" prop="description" label="描述">
                  <template slot-scope="scope">
                    {{!scope.row.description ? '--' : scope.row.description}}
                  </template>
                </el-table-column>
                <el-table-column v-if="form.multipleProjectsMode" prop="descriptionEn" label="描述（英文）">
                  <template slot-scope="scope">
                    {{!scope.row.descriptionEn ? '--' : scope.row.descriptionEn}}
                  </template>
                </el-table-column>
                <el-table-column prop="organizedBy" label="培训团队">
                  <template slot-scope="scope">
                    {{!scope.row.organizedBy ? '--' : scope.row.organizedBy}}
                  </template>
                </el-table-column>
                <el-table-column prop="lecturer" label="培训讲师">
                  <template slot-scope="scope">
                    {{!scope.row.lecturer ? '--' : scope.row.lecturer}}
                  </template> 
                </el-table-column>
                <el-table-column prop="dateRange" label="培训时间">
                  <template slot-scope="scope">{{dateFormat(scope.row.startTime)}} - {{dateFormat(scope.row.endTime)}}</template>
                </el-table-column>
                <el-table-column prop="maxMembers" label="可报名人数"></el-table-column>
                <!-- <el-table-column prop="checkInType" label="签到方式" width="200">
                  <template slot-scope="scope">{{ checkInTypeOptions.find((v) => v.value == scope.row.checkInType).label }}</template>
                </el-table-column> -->
                <el-table-column prop="checkInTimes" label="签到次数"></el-table-column>
                <el-table-column prop="relatedQuestionnaireId" label="关联问卷" width="200" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span v-if="scope.row.relatedQuestionnaireId" class="click" @click="getQuestionnaireDetail(scope.row.relatedQuestionnaireId)">
                        {{ scope.row.relatedQuestionnaireName }}
                      </span>
                      <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作">
                  <template slot-scope="scope">
                    <el-button @click.native.prevent="editSubProjectRow(index, scope.$index)" type="text" size="small">编辑</el-button>
                    <el-button v-if="form.multipleProjectsMode" @click.native.prevent="handleDeleteSubProjectRow(index, scope.$index, scope.row)" type="text" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-button v-show="form.multipleProjectsMode" style="margin-top:15px; margin-left: 30px" icon="el-icon-plus" @click="handleAddSubProjectGroups(index)">新增子项目</el-button>
              <div class="divider"></div>
            </el-card>
            <el-button v-show="form.multipleProjectsMode" type="primary" @click="handleAddProjectGroups">新增项目组</el-button>
          </el-form-item>

          <div class="operation">
            <el-button v-if="!isShowProjectGroups" @click="handleLastStep" size="medium">上一步</el-button>
            <el-button v-if="isShowProjectGroups" @click="backDetailPage" size="medium">取消</el-button>
            <el-button type="primary" @click="handleSaveActivity" size="medium">保存</el-button>
          </div>
        </div>
      </el-form>
    </basic-container>

    <el-dialog title="项目组信息" :before-close="closeProjectGroupsDialog" append-to-body="true" :visible.sync="projectGroupsDialogVisible" width="55%" :close-on-click-modal="false">
      <el-form label-position="top" ref="currentProjectGroupForm" :model="currentProjectGroup" size="medium">
        <el-form-item label="项目组名称" prop="name" :rules="{ required: true, message: '项目组名称不能为空', trigger: 'blur' }">
          <el-input v-model="currentProjectGroup.name" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="项目组名称（英文）" prop="nameEn" :rules="{ required: true, message: '项目组名称（英文）不能为空', trigger: 'blur' }">
          <el-input v-model="currentProjectGroup.nameEn" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="项目组描述" prop="hint">
          <el-input v-model="currentProjectGroup.hint" maxlength="150"></el-input>
        </el-form-item>
        <el-form-item label="项目组描述（英文）" prop="hintEn">
          <el-input v-model="currentProjectGroup.hintEn" maxlength="300"></el-input>
        </el-form-item>
        <el-form-item v-show="form.multipleProjectsChoseMode" label="此项目组内用户可报名的子项目总数">
          <el-col :span="8">
            <el-input-number controls-position="right" v-model="currentProjectGroup.minEnrollProjects" @blur="resetGroupMinEnrollProjects" :step="1" :min="1" :max="currentProjectGroup.maxEnrollProjects" size="medium" v-input-int></el-input-number>
          </el-col>
          <el-col :span="1"> - </el-col>
          <el-col :span="8" :offset="1">
            <el-input-number controls-position="right" v-model="currentProjectGroup.maxEnrollProjects" :step="1" :min="currentProjectGroup.minEnrollProjects" size="medium" v-input-int placeholder="不填则不限制总数"></el-input-number>
          </el-col>
        </el-form-item>
      </el-form>
       <span slot="footer" class="dialog-footer">
        <el-button @click="closeProjectGroupsDialog">取消</el-button>
        <el-button type="primary" @click="saveCurrentProjectGroup">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="子项目信息" append-to-body="true" :before-close="closeSubProjectDialog" :visible.sync="subProjectDialogVisible" width="55%" :close-on-click-modal="false">
      <el-form label-position="top" ref="currentSubProjectForm" :rules="subProjectRule" :model="currentSubProject" size="medium">
        <el-form-item label="子项目名称" prop="name" :rules="{ required: true, message: '子项目名称不能为空', trigger: 'blur' }">
          <el-input v-model="currentSubProject.name" maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="子项目名称（英文）" prop="nameEn" :rules="{ required: true, message: '子项目名称（英文）不能为空', trigger: 'blur' }">
          <el-input v-model="currentSubProject.nameEn" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item v-show="form.multipleProjectsMode" label="子项目描述" prop="description">
          <el-input v-model="currentSubProject.description" maxlength="150"></el-input>
        </el-form-item>
        <el-form-item v-show="form.multipleProjectsMode" label="子项目描述（英文）" prop="descriptionEn">
          <el-input v-model="currentSubProject.descriptionEn" maxlength="300"></el-input>
        </el-form-item>
        <el-form-item :error="organizedByErrorMsg" label="培训团队" prop="organizedBy" class="is-required">
          <el-col :span="15">
            <el-select v-model="currentSelectOrganizedBy" @change="organizedByChange" multiple clearable filterable placeholder="选择培训团队">
              <el-option
                v-for="item in organizedByOptions"
                :key="item.value"
                :label="item.label"
                :value="item.label">
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item :error="lecturerErrorMsg" label="培训老师" prop="lecturer" :class="currentSubProjectLecturerType ? 'is-required' : ''">
          <el-col :span="15">
            <el-radio @change="resetLecturerMsg" v-model="currentSubProjectLecturerType" :label="true">内部员工</el-radio>
            <el-radio @change="resetLecturerMsg" v-model="currentSubProjectLecturerType" :label="false">其他</el-radio>
          </el-col>
          <el-col v-if="!currentSubProjectLecturerType" :span="15">
            <el-input v-model="currentSubProjectExternalLecturer" maxlength="512"></el-input>
          </el-col>
          <el-col v-if="currentSubProjectLecturerType" :span="15">
            <el-tag
              v-for="lecturer in currentSelectLecturers"
              :key="lecturer.unionId"
              closable
              @close="handleLecturerRemove(lecturer)">
              {{lecturer.nickname}}
            </el-tag>
            <el-popover
              width="340"
              placement="bottom-start"
              trigger="click"
              @hide="resetSelectLecturer"
              v-model="isShowPopover"
              v-clickoutside="hiddenSelectTree">
              <el-input
                v-model="lecturerSearch"
                clearable
                @clear="handleClearLecturer"
                @input="resetSelectTree"
                @keyup.enter.native="searchLecturerList"
                class="lecture-input"
                placeholder="搜索培训老师关键字">
              </el-input>
              <el-button class="lecturer-btn" type="primary" @click="searchLecturerList" icon="el-icon-search"></el-button>
              <el-tree v-show="isShowSelect"
                      empty-text="无数据"
                      :highlight-current = true
                      :default-expand-all = false
                      :check-on-click-node= true
                      :expand-on-click-node="false"
                      :data="lecturers"
                      :props="lecturerProps"
                      @node-click="getCheckedNodes"
                      class="lecturerTree">
              </el-tree>
              <el-button class="lecturer-btn" type="primary" slot="reference" icon="el-icon-plus" circle @click="resetLecturerMsg"></el-button>
            </el-popover>
          </el-col>
        </el-form-item>
        <el-form-item label="培训时间" prop="dateRange" :rules="{ required: true, message: '培训时间不能为空', trigger: 'blur' }">
          <el-col :span="15">
            <el-date-picker v-model="currentSubProject.dateRange" @change="changeCheckInDate" type="datetimerange" range-separator="至"
              format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="可报名人数" prop="maxMembers" :rules="{ required: true, message: '可报名人数不能为空', trigger: 'blur' }">
          <el-input-number placeholder="最多报名数量" controls-position="right" v-model="currentSubProject.maxMembers" :step="1" :min="1" size="medium" v-input-int></el-input-number>
        </el-form-item>
        <!-- <el-form-item label="签到方式" prop="checkInType" :rules="{ required: true, message: '签到方式不能为空', trigger: ['blur', 'change'] }">
          <el-col :span="15">
            <el-select v-model="currentSubProject.checkInType">
              <el-option v-for="(type, index) in checkInTypeOptions" :disabled="type.disabled" :key="index" :label="type.label" :value="type.value"></el-option>
            </el-select>
          </el-col>
        </el-form-item> -->
        <el-form-item label="签到次数" prop="checkInTimes" :rules="{ required: true, message: '签到次数不能为空', trigger: 'blur' }">
          <el-input-number @change="onChangeCheckInTimes" placeholder="用户可签到的次数" controls-position="right" v-model="currentSubProject.checkInTimes" :step="1" :min="1" size="medium" v-input-int></el-input-number>
        </el-form-item>
        <el-form-item v-for="index in (currentSubProject.checkInTimes || 0)" :key="index"
          :rules="{ required: true, message: '可签到的时间段不能为空', trigger: 'blur' }"
          :label="`签到时间段${index}`" :prop="`checkInDateRangeList[${index - 1}]`">
          <el-col :span="15">
            <el-date-picker 
              v-model="currentSubProject.checkInDateRangeList[index - 1]"
              type="datetimerange" range-separator="至"
              format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="关联问卷" prop="relatedQuestionnaireId">
          <el-col>
            <div v-if="currentSubProject.relatedQuestionnaireId" style="display:flex">
              <span>
                {{ currentSubProject.relatedQuestionnaireName}}
              </span>
              <el-button
                type="text"
                icon="icon-remove-image"
                @click="removeRelatedQuestionnaire"
              />
            </div>
            <el-button
              v-else
              type="text"
              icon="icon-add-cover"
              @click="showQuestionnaireSelector=true"
            />
          </el-col>
        </el-form-item>
      </el-form>
       <span slot="footer" class="dialog-footer">
        <el-button @click="closeSubProjectDialog">取消</el-button>
        <el-button type="primary" @click="saveSubProject">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="删除项目组"
      :visible.sync="deleteProjectGroupDialogVisible"
       width="35%"
       append-to-body="true">
       <template>
         <el-row class="dialog-body-row">您确定要删除该项目组吗？</el-row>
         <el-row class="dialog-body-row">
          <el-input type="textarea" placeholder="请输入删除该项目组的原因" :rows="3" v-if="isEdit" v-model="messageToDeletedProjectGroup" :maxlength="500"></el-input>
         </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="deleteProjectGroupDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="removeProjectGroups()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="删除子项目"
      :visible.sync="deleteSubProjectRowDialogVisible"
       width="35%"
       append-to-body="true">
       <template>
         <el-row class="dialog-body-row">您确定要删除该子项目吗？</el-row>
         <el-row class="dialog-body-row">
          <el-input type="textarea" placeholder="请输入删除该子项目的原因" :rows="3" v-if="isEdit" v-model="messageToDeleteSubProjectRow" :maxlength="500"></el-input>
         </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="deleteSubProjectRowDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="deleteSubProjectRow()">确定</el-button>
        </el-row>
      </span>
    </el-dialog>
    <el-dialog
      title="您是否确定保存本次编辑？"
      :visible.sync="editConfimrDialogVisible"
      width="35%"
      append-to-body="true"
      @close="handleDelProjectDialogClose">
       <template>
        <!-- <el-row class="dialog-body-row">
          <el-input type="textarea" :rows="3" v-if="form.isNeedSendMessageToEnrolledMembers" v-model="form.messageToEnrolledMembers" :maxlength="512"></el-input>
        </el-row> -->
        <el-row class="dialog-body-row">
          <el-checkbox label="发送短信" v-if="form.status !== 'CREATED' && (groupOrProjectIsDeleted || activityIsUpdated)" v-model="form.isNeedSendMessageToEnrolledMembers"></el-checkbox>  
        </el-row>
       </template>
       <span slot="footer" class="dialog-footer">
        <el-row>
          <el-button @click="editConfimrDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submit">确定</el-button>
        </el-row>
      </span>
    </el-dialog>

    <questionnaire-selector v-if="showQuestionnaireSelector" :dialogVisible="showQuestionnaireSelector" :disabledQuestionnaireIds="projectRelatedQuestionnaireIds" @close="showQuestionnaireSelector=false" @confirm-select="handleSelectQuestionnaire"/>
  </div>
</template>

<script>
import { getOSSActivity, getOSSVideoActivity, getOSSFileActivity } from '@/api/basic/aliyunoss';
import RichTextEditor from '@/components/rich-text-editor/index.vue';
import { checkInTypeOptions, organizedByOptions, categoryOptions } from '@/const/crud/app/activity';
import QuestionnaireSelector from './components/QuestionnaireSelector.vue';
import Api from '@/api/app/activity';
import { getMembersByNickname, getSubLobsByDepartment } from '@/api/admin/member';
import { formatDate } from '@/util/date';
import moment from 'moment';

export default {
  components: {
    RichTextEditor,
    QuestionnaireSelector,
  },
  data() {
    const validateSubProject = (rule, value, callback) => {
      if (!value || !value.length) {
          callback(new Error('请至少添加一个项目组'));
      } else {
        let message = [];
        value.forEach((v, index) => {
          if (!v.subProjectList || !v.subProjectList.length) {
            message.push(index + 1);
          }
        })
        if (message && message.length) {
          callback(new Error(`项目组${message}至少添加一个子项目`));
        } else {
          callback();
        }
      }
    };
    return {
      organizedByOptions: organizedByOptions,
      messageToDeleteSubProjectRow: '',
      messageToDeletedProjectGroup: '',
      deleteSubProjectRowDialogVisible: false,
      deleteProjectGroupDialogVisible: false,
      selectedProjectGroupIndex: undefined,
      deletedProjectGroupIndex: undefined,
      subProjectRowIndex: undefined,
      subProjectRow: {},
      groupOrProjectIsDeleted: false,
      activityIsUpdated: false,
      checkInTypeOptions,
      ossImageFolder: getOSSActivity(),
      ossVideoFolder: getOSSVideoActivity(),
      ossFileFolder: getOSSFileActivity(),
      rules: {
        listPageImage: [
          { required: true, message: "请选择培训列表页图片", trigger: 'blur'},
        ],
        image: [
          { required: true, message: "请选择培训详情页图片", trigger: 'blur'},
        ],
        name: [
          { required: true, message: "请填写培训名称", trigger: 'blur' },
        ],
        nameEn: [
          { required: true, message: "请填写培训名称（英文）", trigger: 'blur' },
        ],
        startEndTime: [
          { required: true, message: "请填写培训时间", trigger: 'blur'},
        ],
        place: [
          { required: true, message: "请填写培训地点", trigger: 'blur' },
        ],
        placeEn: [
          { required: true, message: "请填写培训地点（英文）", trigger: 'blur' },
        ],
        category: [
          { required: true, message: "请选择课程类别", trigger: ['blur', 'change'] },
        ],
        content: [
          { required: true, message: "请填写培训内容" },
        ],
        contentEn: [
          { required: true, message: "请填写培训内容（英文）" },
        ],
        enrollScopes: [
          { required: true, message: "请选择报名范围" }
        ],
        projectGroups: [
          { required: true, message: "请至少添加一个项目组", trigger: ['blur', 'change'] },
          { required: true, validator: validateSubProject, trigger: ['blur', 'change'] },
        ]
      },
      form: {
        listPageImage: "",
        image: "",
        name: "",
        nameEn: "",
        startEndTime: "",
        isOnlyShowDate: false,
        place: "",
        placeEn: "",
        category: "",
        content: "",
        contentEn: "",
        joinEndTime: "",
        joinEndBeforeProjectStartHours: 1,
        cancelJoinEndTime: "",
        useCancelJoinEndTime: false,
        beforeProjectStartHours: 1,
        enrollScopes: [],
        originEnrollScopes: [],
        deleteEnrollScopes: [],
        addEnrollScopes: [],
        needApprove: false,
        organizedBy: '', // TODO: update
        multipleProjectsMode: true,
        multipleProjectsChoseMode: false,
        showCapacity: true,
        showRemainingPlaces: true,
        minEnrollProjects: 1,
        maxEnrollProjects: undefined,
        projectGroups: [],
        deleteProjectGroupIds: [],
        supportQueue: false,
        queueEndBeforeProjectStartHours: 24,
        isNeedSendMessageToEnrolledMembers: false,
        messageToEnrolledMembers: '',
        status: 'CREATED',
      },
      enrollScopeList: [],
      isEdit: false,
      id: "",
      activityTypes: [],
      isBasicInfo: true, // 分为两步， 第一步为基本信息
      isShowProjectGroups: false,
      projectGroupsDialogVisible: false, // 项目组信息弹框
      currentProjectGroup: {}, // 当前选中项目组
      temporaryProjectGroup: {},
      currentProjectGroupIndex: undefined, // 当前选中项目组索引
      isAddProjectGroup: true, // 新增、编辑项目组共用一个弹窗， 故此需要flag标识
      subProjectDialogVisible: false,
      currentSubProject: {},
      temporarySubProject: undefined,
      isAddSubProject: true, // 新增、编辑子项目共用一个弹窗， 故此需要flag标识
      currentSubProjectIndex: undefined,
      isLoaded: false,
      editConfimrDialogVisible: false,
      showQuestionnaireSelector: false,
      isShowSelect: false,
      lecturerProps: {
        label: "value",
      },
      lecturerSearch: '',
      lecturers:[],
      currentSelectLecturers: [],
      currentSelectOrganizedBy: [],
      subLobSearch: '',
      subLobList: [],
      projectRelatedQuestionnaireIds: [], // 已关联子项目的问卷id集合
      lecturerErrorMsg: '',
      organizedByErrorMsg: '',
      isShowPopover: false,
      tempEnrollScopeList: [],
      currentSubProjectLecturerType: true,
      currentSubProjectExternalLecturer: '',
      categoryOptions,
    }
  },
  async mounted() {
    // const response = await this.requestWrapper(Api.getAllActivityTypes);
    // if (response.code === 0) {
    //   this.activityTypes = response.data;
    // } else {
    //   this.$message.error(response.msg);
    // }
  },
  created() {
    console.log(this.courseTypes)
    this.isEdit = this.$route.path.includes('edit');
    if (this.$route.query.isShowProjectGroups) {
      this.isBasicInfo = false;
      this.isShowProjectGroups = true;
    }
    this.form.multipleProjectsMode = this.$route.query.multipleProjectsMode;
    this.id = this.$route.params.id;
    this.initProjectRelatedQuestionnaireIds();
    if (this.isEdit && !isNaN(this.id)) {
      this.initDetail();
    } else {
      this.isLoaded = true;
      Api.fetchEnrollScopes().then(response =>{
        if (response.data.code === 0) {
          this.enrollScopeList = response.data.data;
          this.enrollScopeList.unshift({
            id: -1,
            tagName: '所有人',
          });
          this.tempEnrollScopeList = Object.assign(this.enrollScopeList);
        } else {
          this.$message.error(response.msg);
        }
      });
    }
  },
  watch: {
    'form.enrollScopes': {
      handler(newVal, oldVal){
        this.controlEnrollScopeSelect(newVal, this.enrollScopeList);
      }
    },
  },
  methods: {
    filterMethod(e) {
      this.enrollScopeList = this.tempEnrollScopeList.filter((item) => {
        if (item.tagName.toLowerCase().indexOf(e.toLowerCase()) !== -1) return true;
      });
    },
    dateFormat(datetime) {
      return formatDate('YYYY-mm-dd HH:MM', new Date(datetime));
    },
    onChangeCheckInTimes(val) {
      if (val && val != '0') {
        this.currentSubProject.checkInDateRangeList = [];
        const temp = [];
        for(let i = 0; i < val; i++) {
          temp.push([]);
        }
        this.$set(this.currentSubProject, 'checkInDateRangeList', temp);
      }
    },
    initDetail() {
      Api.getActivity(this.id).then(response => {
        if (response.data.code === 0) {
          let data = response.data.data;
          this.formatDetail(data);
          Api.fetchEnrollScopes().then(response =>{
            if (response.data.code === 0) {
              this.enrollScopeList = response.data.data;
              this.enrollScopeList.unshift({
                id: -1,
                tagName: '所有人',
              });
              let enrollScopes = data.activityScopesVOList;
              if (enrollScopes.length === 0) {
                enrollScopes = [-1];
              }
              const enrollScopeTagIds = this.enrollScopeList.map(tag => tag.id);
              this.form.enrollScopes = enrollScopes.filter(tagId => enrollScopeTagIds.includes(tagId));
              this.form.originEnrollScopes = enrollScopes;
              this.tempEnrollScopeList = Object.assign(this.enrollScopeList);
            } else {
              this.$message.error(response.data.msg);
            }
          });
        } else {
          this.$message({
            message: "无法编辑该培训",
            type: 'error',
          });
        }
        this.isLoaded = true;
      }).catch(error => {
        this.$message({
          message: error,
          type: 'error',
        });
        this.isLoaded = true;
      })
    },
    formatDetail(data) {
      Object.assign(this.form, data);
      this.form.startEndTime = [data.startTime, data.endTime];
    },
    initProjectRelatedQuestionnaireIds() {
      Api.getProjectRelatedQuestionnaireIds().then(response => {
        if (response.data.code === 0) {
          this.projectRelatedQuestionnaireIds = response.data.data;
        } else {
          this.$message(response.data.msg);
        }
      });
    },
    controlEnrollScopeSelect(selectedList, list) {
      if (selectedList.includes(-1)) {
          list = list.map(enrollScope => {
            enrollScope.disabled = enrollScope.id !== -1;
            return enrollScope;
          });
        } else {
          list = list.map(enrollScope => {
            enrollScope.disabled = false;
            return enrollScope;
          });
          if (selectedList.length !== 0) {
            list[0].disabled = true;
          }
        }
    },
    organizedByChange() {
      if (!this.currentSelectOrganizedBy || this.currentSelectOrganizedBy.length === 0) {
        this.organizedByErrorMsg = '培训团队不能为空'
      } else {
        this.organizedByErrorMsg = ''
      }
    },
    searchLecturerList() {
      let _this = this
      let lecturers = []
      let params = {
        nickname: _this.lecturerSearch,
      }
      getMembersByNickname(params).then(response => {
        if (response.status == 200) {
          lecturers = response.data.data
          _this.lecturers = []
          if(lecturers.length === 0) {
            this.$message.warning("未找到相关培训老师");
          }
          if (lecturers && lecturers.length > 0) {
            setTimeout(() => {
              lecturers.forEach(function(lecturer, index) {
                _this.lecturers.push( {value: lecturer.nickname + '(' + lecturer.unionId + ')', nickname: lecturer.nickname, unionId: lecturer.unionId} )
              })
              this.isShowSelect = true
            }, 150);
          }
        }
      }).catch(err => {
      })
    },
    resetSelectLecturer() {
      this.lecturerSearch = '';
      this.isShowPopover = false;
      this.resetSelectTree();
    },
    resetSelectTree() {
      this.lecturers = []
      this.isShowSelect = false
    },
    resetLecturerMsg() {
      this.lecturerErrorMsg = '';
    },
    handleLecturerRemove(item) {
      this.currentSelectLecturers.splice(this.currentSelectLecturers.indexOf(item), 1);
      if (!this.currentSelectLecturers || this.currentSelectLecturers.length === 0) {
        this.lecturerErrorMsg = '培训老师不能为空';
      }
      this.resetSelectLecturer();
    },
    getCheckedNodes(node, e) {
      if(this.currentSelectLecturers.length == 0) {
        this.currentSelectLecturers.push(node);
      } else {
        let count = 0;
        this.currentSelectLecturers.forEach(item => {
          item.unionId === node.unionId && item.nickname === node.nickname  ? count++ : count;
        });
        if (count === 0) {
          this.currentSelectLecturers.push(node);
        } else {
          this.$message.warning('已选择该培训老师');
        }
      }
      this.resetSelectLecturer();
    },
    visibleType(e) {
      this.$nextTick(() => {
			  this.$refs.selectLecture.blur();
		  })
    },
    changeCheckInDate() {
      this.currentSubProject.checkInDateRangeList = [[moment(this.currentSubProject.dateRange[0]).subtract(10, 'minute').format('YYYY-MM-DD HH:mm:ss'), this.currentSubProject.dateRange[1]]];
      this.$forceUpdate();
    },
    handleClearLecturer() {
      this.lecturers = []
      this.isShowSelect = false
    },
    handleImageChange() {
      this.$openMaterialLib((list) => {
        if (list && list.length > 0) {
          this.form.image = list[0].contentUrl;
        }
        this.$refs.ruleForm.validateField('image');
        }, 1);
    },
    handleListPageImageChange() {
      this.$openMaterialLib((list) => {
        if (list && list.length > 0) {
          this.form.listPageImage = list[0].contentUrl;
        }
        this.$refs.ruleForm.validateField('listPageImage');
        }, 1);
    },
    handleNextStep() {
      let needValidateFieldsAfterClickNextStep = ['listPageImage', 'name', 'nameEn', 'startEndTime', 'place', 'placeEn', 'category', 'content', 'contentEn', 'enrollScopes'];

      Promise.all(
        needValidateFieldsAfterClickNextStep.map((field) => {
          return new Promise((resolve, reject) => {
            this.$refs.ruleForm.validateField(field, (errorMsg) => {
              resolve(errorMsg);
            });
          });
        })
      ).then((errorMsgs) => {
        let valid = errorMsgs.every((errorMsgs) => {
          return errorMsgs == '';
        });

        if (valid) {
          this.isBasicInfo = false;
          this.$nextTick(() => {
            const pageNode = this.$el.querySelector('#ruleForm');
            pageNode.scrollIntoView();
          });
        } else {
          this.$message.warning('请正确填写信息');
        }
      });
      if (!this.form.multipleProjectsMode) {
        if (!this.isEdit) {
          this.initProjectGroup();
        }
      }
    },
    initProjectGroup() {
      let subLobList = [];
      const subProject = {
        name: this.form.name,
        nameEn: this.form.nameEn,
        startTime: this.form.startEndTime[0],
        endTime: this.form.startEndTime[1],
        checkInTimes: 1,
        checkInDateRange: [{
          startTime: moment(this.form.startEndTime[0]).subtract(10, 'minute').format('YYYY-MM-DD HH:mm:ss'),
          endTime: this.form.startEndTime[1]
        }],
        checkInType: 2,
        maxMembers: 1,
        unionId: null
      }
      subLobList[0] = subProject;
      const projectGroup = {
        name: this.form.name,
        nameEn: this.form.nameEn,
        hint: "",
        hintEn: "",
        minEnrollProjects: 1,
        subProjectList: subLobList
      }
      this.form.projectGroups[0] = projectGroup;
    },
    handleLastStep() {
      this.isBasicInfo = true;
      this.$nextTick(() => {
        const pageNode = this.$el.querySelector('#ruleForm');
        pageNode.scrollIntoView();
      });
    },
    resetMinEnrollProjects() {
      if(!this.form.minEnrollProjects) {
        this.form.minEnrollProjects = 1;
      }
    },
    resetGroupMinEnrollProjects() {
      if(!this.currentProjectGroup.minEnrollProjects) {
        this.currentProjectGroup.minEnrollProjects = 1;
      }
    },
    handleContentOnBlur() {
      this.$refs.ruleForm.validateField('content');
    },
    handleContentEnOnBlur() {
      this.$refs.ruleForm.validateField('contentEn');
    },
    editProjectGroup(item, index) {
      this.currentProjectGroupIndex = index;
      this.isAddProjectGroup = false;
      this.currentProjectGroup = item;
      this.temporaryProjectGroup = JSON.parse(JSON.stringify(this.currentProjectGroup));
      this.projectGroupsDialogVisible = true;
      this.$refs.currentProjectGroupForm.clearValidate();
    },
    closeProjectGroupsDialog() {
      // this.$refs['currentProjectGroupForm'].resetFields();
      if(this.isEdit || this.form.projectGroups[this.currentProjectGroupIndex]) {
        this.form.projectGroups[this.currentProjectGroupIndex] = this.temporaryProjectGroup;
        this.form.projectGroups[this.currentProjectGroupIndex] = Object.assign({}, this.form.projectGroups[this.currentProjectGroupIndex]);
      }
      this.projectGroupsDialogVisible = false;
    },
    handleAddProjectGroups() {
      this.currentProjectGroup = {
        name: "",
        nameEn: "",
        hint: "",
        hintEn: "",
        minEnrollProjects: 1,
        maxEnrollProjects: undefined,
        isDeleted: false,
        subProjectList: [],
        deleteProjectIds: []
      }
      this.isAddProjectGroup = true;
      this.projectGroupsDialogVisible = true;
      this.$refs.currentProjectGroupForm.clearValidate();
    },
    async removeProjectGroups() {
      if (this.isEdit && this.form.status !== 'CREATED' && (this.messageToDeletedProjectGroup === '' || this.messageToDeletedProjectGroup.trim() === '')) {
        this.$message.error('删除项目组原因不能为空');
        return;
      }
      const projectGroup = this.form.projectGroups[this.deletedProjectGroupIndex];
      const projectGroupId = projectGroup.id;
      if (projectGroupId) {
        const param = {
          id: projectGroupId,
          reason: this.messageToDeletedProjectGroup
        }
        this.form.deleteProjectGroupIds.push(param);
      }
      this.form.projectGroups.splice(this.deletedProjectGroupIndex, 1);
      this.$refs.ruleForm.validateField('projectGroups');
      this.messageToDeletedProjectGroup = '';
      this.groupOrProjectIsDeleted = true;
      this.deleteProjectGroupDialogVisible = false;
    },
    handleSelectQuestionnaire(selectedQuestionnaire) {
      this.currentSubProject.relatedQuestionnaireId = selectedQuestionnaire.id;
      this.currentSubProject.relatedQuestionnaireName = selectedQuestionnaire.name;
      this.projectRelatedQuestionnaireIds.push(selectedQuestionnaire.id);
    },
    removeRelatedQuestionnaire() {
      const relatedQuestionnaireIdIndex = this.projectRelatedQuestionnaireIds.indexOf(this.currentSubProject.relatedQuestionnaireId);
      this.projectRelatedQuestionnaireIds.splice(relatedQuestionnaireIdIndex, 1);
      this.currentSubProject.relatedQuestionnaireId = undefined;
    },
    getQuestionnaireDetail(questionnaireId) {
      const routeData =this.$router.resolve({
        path: `/app/questionnaire/detail/${questionnaireId}`,
      });
      window.open(routeData.href,'_blank');
    },
    cancel () {
      this.$router.$avueRouter.closeTag();
      this.$router.go(-1);
    },
    handleSaveActivity() {
      this.$refs.ruleForm.validate((valid, result) => {
        if (valid) {
          if (this.isEdit) {
            if (this.form.status !== 'CREATED') {
              const params = Object.assign({}, this.form);
              params.startTime = params.startEndTime[0];
              params.endTime = params.startEndTime[1];
              Api.checkActivityIsUpdated(params).then(response => {
                if (response.data.code === 0) {
                  this.activityIsUpdated = response.data.data;
                } else {
                  this.activityIsUpdated = false;
                }
              });
            }
            this.editConfimrDialogVisible = true;
          } else {
            const currentSubProject = this.form.projectGroups[0].subProjectList[0]
            if (!currentSubProject.checkInDateRange) {
              this.$message.warning('可签到的时间段不能为空');
            } else if (!currentSubProject.organizedByList || currentSubProject.organizedByList.length === 0) {
              this.$message.warning('培训团队不能为空');
            } else if (this.currentSubProjectLecturerType && (!currentSubProject.lecturerList || currentSubProject.lecturerList.length === 0)) {
              this.$message.warning('培训老师不能为空');
            } else {
              this.submit();
            }
          }
        } else {
          this.$message.warning('请正确填写信息');
        }
      });
    },
    submit() {
      this.$refs.ruleForm.validate(async (valid, result) => {
        const params = Object.assign({}, this.form);
        params.enrollScopes = Array.from(this.form.enrollScopes);
        if (this.isEdit) {
          params.addEnrollScopes = params.enrollScopes.filter(tag => !params.originEnrollScopes.includes(tag) && tag !== -1);
          params.deleteEnrollScopes = params.originEnrollScopes.filter(tag => !params.enrollScopes.includes(tag) && tag !== -1);
        }
        params.enrollScopes = params.enrollScopes.includes(-1) ? [] : params.enrollScopes;
        params.startTime = params.startEndTime[0];
        params.endTime = params.startEndTime[1];
        if (valid) {
          const func = this.isEdit ? Api.editActivity : Api.createActivity;
          func(params).then(response => {
            if (response.data.code === 0) {
              this.$message({
                message: this.isEdit ? '编辑成功' : '创建成功',
                type: 'success',
              });
              if (this.isShowProjectGroups) {
                this.backDetailPage()
              } else {
                this.$router.$avueRouter.closeTag();
                this.$router.go(-1);
              }
            } else {
              console.log(response);
              this.$message({
                message: response.data.msg,
                type: 'error',
              });
            }
          });
        } else {
          this.$message({
            message: result[Object.keys(result)[0]][0].message || '请正确填写培训信息',
            type: 'warning'
          });
          return false;
        }
      });
    },
    saveCurrentProjectGroup() {
      this.$refs.currentProjectGroupForm.validate((valid) => {
        if (valid) {
          if (this.isAddProjectGroup) {
            this.form.projectGroups.push(this.currentProjectGroup);
            this.temporaryProjectGroup = JSON.parse(JSON.stringify(this.currentProjectGroup));
            this.$refs.ruleForm.validateField('projectGroups');
          } else {
            this.form.projectGroups[this.currentProjectGroupIndex] = this.currentProjectGroup;
          }
          this.projectGroupsDialogVisible = false;
        } else {
          this.$message.warning('请正确填写信息');
        }
      });
    },
    closeSubProjectDialog() {
      if(this.form.projectGroups[this.currentProjectGroupIndex].subProjectList && this.temporarySubProject) {
        this.form.projectGroups[this.currentProjectGroupIndex].subProjectList[this.currentSubProjectIndex] = JSON.parse(JSON.stringify(this.temporarySubProject));
        this.form.projectGroups[this.currentProjectGroupIndex].subProjectList = Object.assign([], this.form.projectGroups[this.currentProjectGroupIndex].subProjectList);
      }
      this.lecturerErrorMsg = '';
      this.organizedByErrorMsg = '';
      this.lecturers = [];
      this.currentSelectLecturers = [];
      this.currentSubProjectLecturerType = true;
      this.currentSubProjectExternalLecturer = '';
      this.currentSelectOrganizedBy = [];
      this.isShowSelect = false;
      this.temporarySubProject = undefined;
      this.subProjectDialogVisible = false;
    },
    editSubProjectRow(selectedProjectGroupIndex, index) {
      this.currentProjectGroupIndex = selectedProjectGroupIndex;
      this.currentSubProjectIndex = index;
      this.isAddSubProject = false;
      this.currentSubProject = this.form.projectGroups[selectedProjectGroupIndex].subProjectList[index];
      if (this.currentSubProject.unionId !== null && this.currentSubProject.unionId.trim() === '') {
        this.currentSubProjectLecturerType = false;
        if (this.currentSubProject.lecturer !== null && this.currentSubProject.lecturer.trim() !== '') {
          this.currentSubProjectExternalLecturer = this.currentSubProject.lecturer;
        } 
      } else {
        this.currentSubProjectLecturerType = true;
      }
      if (this.currentSubProjectLecturerType && this.currentSubProject.lecturerList) {
        this.currentSelectLecturers = this.currentSubProject.lecturerList;
      }
      if (this.currentSubProject.organizedByList) {
        this.currentSelectOrganizedBy = this.currentSubProject.organizedByList;
      }
      this.temporarySubProject = JSON.parse(JSON.stringify(this.currentSubProject));
      this.$set(this.currentSubProject, 'dateRange', [this.currentSubProject.startTime, this.currentSubProject.endTime])
      let temp = [];
      if (this.currentSubProject.checkInDateRange && this.currentSubProject.checkInDateRange.length) {
        this.currentSubProject.checkInDateRange.forEach((item) => {
          temp.push([item.startTime, item.endTime]);
        })
      } else {
        temp.push([moment(this.currentSubProject.dateRange[0]).subtract(10, 'minute').format('YYYY-MM-DD HH:mm:ss'), this.currentSubProject.dateRange[1]]);
      }
      this.$set(this.currentSubProject, 'checkInDateRangeList', temp);
      // this.fetchSubLobList();
      this.subProjectDialogVisible = true;
      this.$refs.currentSubProjectForm.clearValidate();
    },
    fetchSubLobList() {
      let params = {
        department: '',
      }
      getSubLobsByDepartment(params).then(response => {
          if (response.status == 200) {
          this.subLobList = response.data.data
        }
      }).catch(err => {
      })
    },
    handleDeleteSubProjectRow(selectedProjectGroupIndex, index, row) {
      this.selectedProjectGroupIndex = selectedProjectGroupIndex;
      this.subProjectRowIndex = index;
      this.subProjectRow = row;
      this.deleteSubProjectRowDialogVisible = true;
    },
    handleRemoveProjectGroups(index) {
      this.deletedProjectGroupIndex = index;
      this.deleteProjectGroupDialogVisible = true;
    },
    deleteSubProjectRow() {
      if (this.isEdit && this.form.status !== 'CREATED' && (this.messageToDeleteSubProjectRow === '' || this.messageToDeleteSubProjectRow.trim() === '')) {
        this.$message.error('删除子项目原因不能为空');
        return;
      }
      const project = this.subProjectRow;
      const projectId = project.id;
      if (projectId) {
        const deleteProjectIds = this.form.projectGroups[this.selectedProjectGroupIndex].deleteProjectIds;
        if (!deleteProjectIds) {
          this.form.projectGroups[this.selectedProjectGroupIndex].deleteProjectIds = [];
        }
        const param = {
          id: projectId,
          reason: this.messageToDeleteSubProjectRow
        }
        this.form.projectGroups[this.selectedProjectGroupIndex].deleteProjectIds.push(param);
          
      }
      const relatedQuestionnaireIdIndex = this.projectRelatedQuestionnaireIds.indexOf(this.form.projectGroups[this.selectedProjectGroupIndex].subProjectList[this.subProjectRowIndex].relatedQuestionnaireId);
      this.projectRelatedQuestionnaireIds.splice(relatedQuestionnaireIdIndex, 1);
      this.form.projectGroups[this.selectedProjectGroupIndex].subProjectList.splice(this.subProjectRowIndex, 1);
      this.$refs.ruleForm.validateField('projectGroups');
      this.messageToDeletedProject = '';
      this.groupOrProjectIsDeleted = true;
      this.deleteSubProjectRowDialogVisible = false;
    },
    handleAddSubProjectGroups(selectedProjectGroupIndex) {
      this.currentSubProject = {
        name: '',
        nameEn: '',
        description: '',
        descriptionEn: '',
        organizedBy: '',
        lecturer: '',
        unionId: '',
        dateRange: [],
        startTime: '',
        endTime: '',
        maxMembers: '',
        checkInType: 2,
        checkInTimes: '',
        checkInDateRangeList: [],
        relatedQuestionnaireId: undefined,
        relatedQuestionnaireName: '',
      }
      this.currentProjectGroupIndex = selectedProjectGroupIndex;
      // this.fetchSubLobList();
      this.currentSubProjectLecturerType = true;
      this.subProjectDialogVisible = true;
      this.$refs.currentSubProjectForm.clearValidate();
      this.isAddSubProject = true;
    },
    saveSubProject() {
      this.$refs.currentSubProjectForm.validate((valid) => {
        if (this.currentSubProjectLecturerType && (!this.currentSelectLecturers || this.currentSelectLecturers.length === 0)) {
          this.lecturerErrorMsg = '培训老师不能为空';
        }
        if (!this.currentSelectOrganizedBy || this.currentSelectOrganizedBy.length === 0) {
          this.organizedByErrorMsg = '培训团队不能为空';
        }
        if (valid && this.lecturerErrorMsg === '' && this.organizedByErrorMsg === '') {
          this.currentSubProject.organizedByList = this.currentSelectOrganizedBy;
          if (this.currentSubProjectLecturerType) {
            this.currentSubProject.lecturerList = this.currentSelectLecturers;
            this.currentSubProject.lecturer = this.currentSelectLecturers.map(item => item.nickname).join(', ');
            this.currentSubProject.unionId = this.currentSelectLecturers.map(item => item.unionId).join(', ');
          } else {
            this.currentSubProject.lecturerList = [];
            this.currentSubProject.unionId = ''
            this.currentSubProject.lecturer = this.currentSubProjectExternalLecturer;
          }
          this.currentSubProject.organizedBy = this.currentSelectOrganizedBy.join(', ');
          this.currentSubProject.startTime = this.currentSubProject.dateRange[0];
          this.currentSubProject.endTime = this.currentSubProject.dateRange[1];
          let temp = [];
          if (this.currentSubProject.checkInDateRangeList && this.currentSubProject.checkInDateRangeList.length) {
            this.currentSubProject.checkInDateRangeList.forEach((item) => {
              temp.push({ 'startTime': item[0], 'endTime': item[1]});
            });
            this.currentSubProject.clearCheckinDateRange = true;
          }
          this.$set(this.currentSubProject, 'checkInDateRange', temp);
          if (this.isAddSubProject) {
            if (!this.form.projectGroups[this.currentProjectGroupIndex].subProjectList || !this.form.projectGroups[this.currentProjectGroupIndex].subProjectList.length) {
              this.form.projectGroups[this.currentProjectGroupIndex].subProjectList = [];
            }
            this.form.projectGroups[this.currentProjectGroupIndex].subProjectList.push(this.currentSubProject)
            this.temporarySubProject = JSON.parse(JSON.stringify(this.currentSubProject));
            this.temporaryProjectGroup = JSON.parse(JSON.stringify(this.form.projectGroups[this.currentProjectGroupIndex]));
            this.$refs.ruleForm.validateField('projectGroups');
          } else {
            this.form.projectGroups[this.currentProjectGroupIndex].subProjectList[this.currentSubProjectIndex] = this.currentSubProject;
            this.$set(this.form.projectGroups[this.currentProjectGroupIndex].subProjectList, this.currentSubProjectIndex, this.currentSubProject);
          }
          this.lecturers = [];
          this.currentSelectLecturers = [];
          this.currentSelectOrganizedBy = [];
          this.currentSubProjectExternalLecturer = '';
          this.isShowSelect = false;
          this.subProjectDialogVisible = false;
        } else {
          this.$message.warning('请正确填写信息');
        }
      });
    },
    backDetailPage() {
      this.$router.push({ path: `/app/activity/detail/${this.id}?showTab=activityProject` })
    }
  },
  directives: {
    'input-int': {
      bind: function(el) {
        el.onkeypress = function(e) {
          return (/[\d]/.test(String.fromCharCode(e.keyCode || e.which))) || e.which === 8;
        }
      }
    }
  }
}
</script>

<style>
.enroll-scopes-select .el-scrollbar {
  margin-bottom: 0;
}
</style>

<style lang="scss" scoped>
.app-container {
  max-height: calc(100% - 50px);
  max-width: calc(100% - 254px);
  position: fixed;
  overflow-y: scroll;
  // padding-bottom: 150px;
}
/deep/ .el-card__body {
  padding: 0;
  padding-bottom: 50px;
}
#ruleForm {
  padding: 20px;
}
.tip-icon {
  position: relative;
  top: -36px;
  right: -80px;
  transform: scale(1.3,1.3);
  cursor: pointer;
  color: #66b1ff;
}
</style>
<style lang="scss">
.single-row {
  font-size: 14px;
  margin: 30px 20px;
  &-value {
    display: flex;
    align-items: center;
  }
}

.image-upload-tip {
  font-size: 12px;
  color: #7a869e;
}

.activity-image-wrapper {
  position: relative;
  width: 708px;
  .activity-image {
    width: 708px;
  }

  .activity-list-page-image {
    width: 318px;
  }

  .icon-remove-image {
    position: absolute;
    right: -15px;
    top: 0;
  }
}

.project_groups {
  margin: 20px 0;
  padding: 10px;
  background-color: #f6f8fb;
  .el-form-item {
    margin-bottom: 15px;
  }
}

.operation {
  text-align: right
}

.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}

.pagination button {
  flex-grow: 1;
}

.pagination button:hover {
  cursor: pointer;
}

.el-form .el-form-item--medium .el-form-item__label {
  line-height: 15px;
}

.el-form-item.is-success .el-input__inner,
.el-form-item.is-success .el-input__inner:focus, 
.el-form-item.is-success .el-textarea__inner,
.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #c0c4cc;
}

.divider {
  background-color: #7a869e;
  width: 100%;
  height: 2px;
  margin-top: 50px;
}

.dialog-body-row {
  margin-top: 8px;
}

.click {
  color: #409eef;
  cursor: pointer;
}
.lecturerTree {
  position: absolute;
  overflow: auto;
  z-index: 100;
  width: 74%;
  height: auto;
  max-height: 200px;
  border: 1px solid #ddd;
  border-radius: 5px;
  line-height: normal; 
  z-index: 204;
}
.lecturerTree::-webkit-scrollbar {
  width: 4px;
  height: 6px;
}
.lecturerTree::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}
.lecturerTree::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
}

.lecture-select .el-icon-arrow-up:before {
  content: '';
}

.lecturer-btn {
  margin-left: 10px;
}

.lecture-input {
  width: 80%;
}

.el-tag {
  margin-right: 5px;
}

</style>
